module.exports = __webpack_public_path__ + "img/riviera-maya.d6583e5d.png";